import { TextField } from "@mui/material";
import { MobilePhoneMask } from "../../../../components/Mask/DelendTextMask";

interface MobilePhoneProps {
  register: any;
  errors: any;
}

const MobilePhoneInput: React.FC<MobilePhoneProps> = ({ register, errors }) => {
  return (
    <TextField
      fullWidth
      {...register("mobilePhone")}
      label="Celular"
      required
      error={!!errors.mobilePhone}
      helperText={errors.mobilePhone?.message}
      variant="standard"
      inputProps={{
        style: {
          fontSize: 16,
          height: 30,
        },
      }}
      InputProps={{ inputComponent: MobilePhoneMask as any }}
    />
  );
};

export default MobilePhoneInput;
